export function isFullHtmlDocument(text: string): boolean {
  if (!text || text.length < 10) return false;

  const normalized = text.trim().toLowerCase();

  const hasDoctype = normalized.startsWith("<!doctype html");
  const startsWithHtml = /^<html[\s>]/i.test(normalized);

  if (!hasDoctype && !startsWithHtml) return false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");

  const hasHead = doc.head !== null;
  const hasBody = doc.body !== null && doc.body.children.length > 0;

  const hasHtmlTag = /<html[\s>]/i.test(text);

  return (hasDoctype || hasHtmlTag) && hasHead && hasBody;
}
